export const FETCH_DISTRIBUTORS_INIT_ACTION = "FETCH_DISTRIBUTORS_INIT_ACTION";
export const FETCH_DISTRIBUTORS_SUCCESS_ACTION =
  FETCH_DISTRIBUTORS_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRIBUTORS_FAIL_ACTION =
  FETCH_DISTRIBUTORS_INIT_ACTION + "_ERROR";

export const FETCH_DISTRIBUTORSTATUS_INIT_ACTION =
  "FETCH_DISTRIBUTORSTATUS_INIT_ACTION";
export const FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION =
  FETCH_DISTRIBUTORSTATUS_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRIBUTORSTATUS_FAIL_ACTION =
  FETCH_DISTRIBUTORSTATUS_INIT_ACTION + "_ERROR";

export const FETCH_DETAILVIEW_INIT_ACTION = "FETCH_DETAILVIEW_INIT_ACTION";
export const FETCH_DETAILVIEW_SUCCESS_ACTION =
  FETCH_DETAILVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_DETAILVIEW_FAIL_ACTION =
  FETCH_DETAILVIEW_INIT_ACTION + "_ERROR";


  export const FETCH_DISTRIBUTORORGSTATUS_INIT_ACTION =
  "FETCH_DISTRIBUTORORGSTATUS_INIT_ACTION";
export const FETCH_DISTRIBUTORORGSTATUS_SUCCESS_ACTION =
  FETCH_DISTRIBUTORORGSTATUS_INIT_ACTION + "_SUCCESS";
export const FETCH_DISTRIBUTORORGSTATUS_FAIL_ACTION =
  FETCH_DISTRIBUTORORGSTATUS_INIT_ACTION + "_ERROR";



export function fetchDistributors(value) {
  return {
    type: FETCH_DISTRIBUTORS_INIT_ACTION,
    value: value
  };
}

export function pageSelected(value) {
  // console.log(value);
  return {
    type: FETCH_DISTRIBUTORS_INIT_ACTION,
    value: value
  };
}

export function ChangeStatus(value) {
  return {
    type: FETCH_DISTRIBUTORSTATUS_INIT_ACTION,
    value: value
  };
}

export function DistributorDetailView(value) {
  return {
    type: FETCH_DETAILVIEW_INIT_ACTION,
    value
  };
}
